import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { Bank, RefundAccount, RefundAccountCheck } from '~/api/model';

// Response 타입 (Zod Model 재사용 — OAISchema 금지, api-typegen §0)
type RefundAccountResponse = RefundAccount;
type RefundAccountCheckResponse = RefundAccountCheck;
type BankResponse = Bank;

// Request DTO 직접 정의 (OAISchema 금지 — §0)
export type RefundAccountRequestV2 = {
  accountNumber: string;
  bankCode: string;
  vendorId?: number;
};
export type ValidateAccountHolderRequest = {
  accountNumber: string;
  bankCode: string;
  holderName: string;
};
export type RefundAccountCheckRequest = {
  accountNumber: string;
  bankCode: string;
};

export interface RefundDataSource {
  // Query
  getRefundAccount(): Promise<RefundAccountResponse>;
  getRefundBankList(): Promise<BankResponse[]>;

  // Mutation
  updateRefundAccount(
    data: RefundAccountRequestV2,
  ): Promise<RefundAccountResponse>;
  validateAccountHolder(
    data: ValidateAccountHolderRequest,
  ): Promise<RefundAccountResponse>;
  checkRefundAccount(
    data: RefundAccountCheckRequest,
  ): Promise<RefundAccountCheckResponse>;
}

export class RefundDataSourceImpl implements RefundDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getRefundAccount() {
    return this.client.request<RefundAccountResponse>({
      url: '/api/market-place/v1/payments/refund-account',
      method: 'get',
    });
  }

  async getRefundBankList() {
    return this.client.request<BankResponse[]>({
      url: '/api/market-place/v1/payments/kpn/vacct/bank-refund',
      method: 'get',
    });
  }

  async updateRefundAccount(data: RefundAccountRequestV2) {
    return this.client.request<RefundAccountResponse>({
      url: '/api/market-place/v2/payments/refund-account',
      method: 'put',
      data,
    });
  }

  async validateAccountHolder(data: ValidateAccountHolderRequest) {
    return this.client.request<RefundAccountResponse>({
      url: '/api/market-place/v1/payments/validate-account-holder',
      method: 'post',
      data,
    });
  }

  async checkRefundAccount(data: RefundAccountCheckRequest) {
    return this.client.request<RefundAccountCheckResponse>({
      url: '/api/market-place/v2/payments/refund-account-check',
      method: 'post',
      data,
    });
  }
}

export const refundDataSource = new RefundDataSourceImpl();
